import api from "@/api/api";
import { iniciarRequisicao, logout } from "@/helpers";
import { STATUS_HTTP } from "@/api/statusHTTP";

const PREFIXO = 'coberturas';

export const buscarTipoFornecedor = async (parametros) => {
  const url = `/${PREFIXO}/estoque-seguranca/buscar-tipo-fornecedor`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.tipo_fornecedor;
}

export const buscarFornecedor = async (parametros) => {
  const url = `/${PREFIXO}/estoque-seguranca/buscar-fornecedor`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.fornecedor;
}

export const buscarCurvasFornecedor = async (parametros) => {
  const url = `/${PREFIXO}/estoque-seguranca/buscar-curvas-fornecedor`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.curvas;
}

export const buscarFamiliaProdutoFornecedor = async (parametros) => {
  const url = `/${PREFIXO}/estoque-seguranca/buscar-familia-produto-fornecedor`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.familia_produto;
}

export const buscarProdutosFornecedor = async (parametros) => {
  const url = `/${PREFIXO}/estoque-seguranca/buscar-produtos-fornecedor`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.produtos;
}

export const salvarEssegCurvasFornecedor = async (parametros) => {
  const url = `/${PREFIXO}/estoque-seguranca/salvar-esseg-curvas-fornecedor`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}

export const salvarEssegPorFornecedor = async (parametros) => {
  const url = `/${PREFIXO}/estoque-seguranca/salvar-esseg-por-fornecedor`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}

export const salvarEssegProdutoFornecedor = async (parametros) => {
  const url = `/${PREFIXO}/estoque-seguranca/salvar-esseg-produto-fornecedor`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}

export const salvarEssegFamiliaProdutoFornecedor = async (parametros) => {
  const url = `/${PREFIXO}/estoque-seguranca/salvar-esseg-familia-produto-fornecedor`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}

export const salvarEssegAutomatico = async (parametros) => {
  const url = `/${PREFIXO}/estoque-seguranca/salvar-esseg-automatico`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return ;
}
